var _circle, _circle2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesktopIllustration2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 164,
    viewBox: "0 0 164 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 82,
    cy: 82,
    r: 82,
    fill: "#61E5E9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2065_28809",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 152,
    height: 152
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.9999,
    cy: 82,
    r: 75.2909,
    fill: "#73E5FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2065_28809)"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 82.0006,
    cy: 82,
    r: 76.7818,
    fill: "#39E4B9"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2065_28809)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 31,
    width: 80,
    height: 102,
    rx: 9.07216,
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 93,
    width: 64,
    height: 8,
    rx: 4,
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 105,
    width: 64,
    height: 8,
    rx: 4,
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 117,
    width: 64,
    height: 8,
    rx: 4,
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 39,
    width: 64,
    height: 46,
    rx: 8,
    fill: "#F4F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.049 33.927C111.348 33.0057 112.652 33.0057 112.951 33.9271L114.021 37.2188C114.155 37.6309 114.538 37.9098 114.972 37.9098H118.433C119.402 37.9098 119.804 39.1494 119.021 39.7188L116.22 41.7533C115.87 42.0079 115.723 42.4593 115.857 42.8713L116.927 46.1631C117.226 47.0844 116.172 47.8506 115.388 47.2812L112.588 45.2467C112.237 44.9921 111.763 44.9921 111.412 45.2467L108.612 47.2812C107.828 47.8506 106.774 47.0844 107.073 46.1631L108.143 42.8713C108.277 42.4593 108.13 42.0079 107.78 41.7533L104.979 39.7188C104.196 39.1494 104.598 37.9098 105.567 37.9098H109.028C109.462 37.9098 109.845 37.6309 109.979 37.2188L111.049 33.927Z",
    fill: "#FFA41C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2065_28809",
    x: 31.7938,
    y: 21.9278,
    width: 100.412,
    height: 122.412,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.13402
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.10309
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2065_28809"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2065_28809",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopIllustration2);
export default __webpack_public_path__ + "static/media/desktop-illustration-2.38319411.svg";
export { ForwardRef as ReactComponent };